import { render, staticRenderFns } from "./ApplicantFormStep2.vue?vue&type=template&id=9145b36c&scoped=true"
import script from "./ApplicantFormStep2.vue?vue&type=script&lang=js"
export * from "./ApplicantFormStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9145b36c",
  null
  
)

export default component.exports